import PropTypes from "prop-types";
import cn from "classnames";
import Link from "next/link";
import { pluralizeWord } from "helpers/formatting";
import ChatButton from "components/shared/adventures/ChatButton";
import styles from "components/wsl/Departure.module.scss";

export default function Departure({
  variantID,
  spotsLeft,
  noAccommodations,
}) {
  return (
    <div className={styles.component}>
      <div>
        <div className={styles.dates}>
          {noAccommodations ? "No accommodations" : "Accommodations included"}
        </div>
        <div className={styles.status}>
          {spotsLeft > 0 ? `${spotsLeft} ${pluralizeWord("spot", "spots", spotsLeft)} left` : "Fully booked"}
        </div>
      </div>
      {spotsLeft > 0 ? (
        <Link
          prefetch={false}
          href={`/book/events/pay?event_variant_id=${variantID}&num_adults=1&num_children=0&is_deposit=true&individual_rooms=true`}
        >
          <button
            type="button"
            size={1}
            className={cn(styles.button, styles.buttonPrimary)}
          >
            Book now
          </button>
        </Link>
      ) : (
        <ChatButton
          type="button-wrapper"
          text="Join waitlist"
          className={cn(styles.button, styles.buttonGhost)}
        />
      )}
    </div>
  );
}

Departure.propTypes = {
  variantID: PropTypes.string,
  spotsLeft: PropTypes.number,
  noAccommodations: PropTypes.bool,
};
